import React, { useState } from 'react'; 
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import { useNavigate } from 'react-router-dom';
import '../../styles/timesheetStyles/TimesheetDetails.css';

const TimeSheetProjectDetails = ({ children, activeTab, setActiveTab, tabsTitle = 'TimeSheets' }) => {
  const [status, setStatus] = useState('In Progress'); // Initialize the status

  const handleStatusChange = (event) => {
    setStatus(event.target.value); 
  };

  const navigate = useNavigate();
  
  return (
    <div className="timesheetdetails-layout-container">
      <Header />
      <div className="timesheetdetails-content">
        <div className="timesheets-container">
          <h2 className="timesheetdetails-title">{tabsTitle}</h2>
          <div className="tabs">
            <button
              className={`tab-item ${activeTab === 'Timesheets Details' ? 'active' : ''}`}
              onClick={() => navigate('/timesheets')} >
              <img src="/images/back.svg" alt="New Project" className="tab-icon" />
                Timesheets Details
              <img src="/images/Rectangle.png" alt="Additional" className="below-image" />
            </button>
          </div>
        </div>
        <div className="content-inner">{children}</div>
      </div>

      <div className="timesheetdetailsScreen">
      <div className="update-status">
          <div className="header-row">
            <h3>Timesheet Date</h3>
            <div className="status-badge" style={{ backgroundColor: status === 'Completed' ? '#8ABE14' : '#E59A0A' }}>
              <span>
                {status === 'In Progress' ? (
                  <img src="/images/in-progress.png" alt="In Progress " className="icons-status"/>
                ) : (
                  <img src="/images/timesheetstatus.png" alt="Completed " className="icons-status" />
                )}
                {status}
              </span>
            </div>
          </div>

          <div className="timesheet-details">
            <div className="timesheet-dates">
              <p>Start Date</p>
              <span>12th Jan, 2024</span>
            </div>
            <div className="timesheet-dates">
              <p>End Date</p>
              <span>19th Jan, 2024</span>
            </div>
          </div>
          <div className="timesheet-hrs">
            <p>Total Time</p>
            <span>17 Hrs</span>
          </div>

          <hr />

          <div className="status-section">
            <label className="status-sec">Status</label>
            <select value={status} onChange={handleStatusChange} className="custom-select">
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
            <span className="custom-arrow"></span>
          </div>

          <button className="update-button">Update Status</button>
        </div>
        <div className="main-container">

        <div className="addr-header-container">
            <h3 className="title-addr">Chad Stevenson</h3>
            <div className="edit-option">
        <img src="/images/edit.png" alt="Edit Icon" className="edit-icon" /> 
        <span className="edit">Edit</span>
        </div>
        </div>

        <div className="name-row">
        <h3 className="address-title">05, Gill St,Toronto,ON</h3>
                <div className="total-hrs">
        <span>Total Time: 10 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
        <div className="name-detail-column">
    <p className="name-title">Construction and Carpentry</p>
    <p className="name-list">Interior Finish Carpentry</p>
    <p className="name-list">Vanity Installs</p>
    <p className="name-list">Trim Carpentry</p>
  </div>


  <div className="name-detail-column line">
    <p className="date-list">12th Jan,2024</p>
    <p className="date-list">13th Jan,2024</p>
    <p className="date-list">15th Jan,2024</p>
  </div>


  <div className="name-detail-column line">
    <p className="time-list">9:00am  to  2:00pm
    <img className="time-image" src="/images/location.png" alt="Time" />
    </p>
    <p className="time-list">10:00am  to  12:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
    <p className="time-list">8:00am  to  1:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
  </div>

  <div className="name-detail-column">
    <p className="hour-list">5 hr</p>
    <p className="hour-list">2 hr</p>
    <p className="hour-list">5 hr</p>
  </div>
        
          </div>
        <div className="name-row">
        <h3 className="address-title">123 King St,Etobicoke,ON</h3>
                <div className="total-hrs">
        <span>Total Time: 10 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
        <div className="name-detail-column">
    <p className="name-title">Electrical Work</p>
    <p className="name-list">Fixture Installation</p>
    <p className="name-list">Panel Upgrade</p>
    <p className="name-list">Soft Lighting</p>
  </div>


  <div className="name-detail-column line">
    <p className="date-list">12th Mar,2024</p>
    <p className="date-list">7th Jun,2024</p>
    <p className="date-list">10th Oct,2024</p>
  </div>


  <div className="name-detail-column line">
    <p className="time-list">9:00am  to  2:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
    <p className="time-list">10:00am  to  1:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
    <p className="time-list">8:00am  to  10:00am
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
  </div>

  <div className="name-detail-column">
    <p className="hour-list">5 hr</p>
    <p className="hour-list">3 hr</p>
    <p className="hour-list">2 hr</p>
  </div>
        
          </div>
        
        <div className="name-row">
        <h3 className="address-title">48 Margrove St,Brampton,ON</h3>
                <div className="total-hrs">
        <span>Total Time: 12 Hrs </span>
        </div>
        </div>
        <div className="name-detail-row">
        <div className="name-detail-column">
    <p className="name-title">Material Handling</p>
    <p className="name-list">Material Deliveries</p>
    <p className="name-list">Deliveries</p>
  </div>


  <div className="name-detail-column line">
    <p className="date-list">12th Sept,2024</p>
    <p className="date-list">8th Nov,2024</p>
  </div>


  <div className="name-detail-column line">
    <p className="time-list">9:00am  to  2:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
    <p className="time-list">10:00am  to  3:00pm
    <img className="time-image" src="/images/location.png" alt="Time " />
    </p>
    
  </div>

  <div className="name-detail-column">
    <p className="hour-list">6 hr</p>
    <p className="hour-list">6 hr</p>
  </div>
        
          </div>
      </div>
      </div>

      <div className="button-section">
      <button className="export-button" >
      Export Excel </button>
      <button className="download-button" >
      Download Pdf </button>

      </div>
      <Footer />
    </div>
  );
};

export default TimeSheetProjectDetails;
